<template>

  <div class="page">
    <main-nav></main-nav>
    <landing class="landing"></landing>
    <!--<promotion-banner class="promotions"></promotion-banner>-->
    <about-us class="landing"></about-us>
    <gallery class="gallery"></gallery>
    <promotions class="promotions"></promotions>
    <!-- <supermarket class="supermarket"></supermarket>
    <butchery class="butchery"></butchery>
    <meat-plant class="meat-plant"></meat-plant>
    <distribution-centre class="distribution-centre"></distribution-centre> -->
    <store-locator class="store-locator"></store-locator>
    <contact-us class="contact-us"></contact-us>
    <j-footer class="footer"></j-footer>
  </div>

</template>

<script>
import MainNav from '@/components/MainNav'
import Landing from '@/components/Landing'
import AboutUs from '@/components/AboutUs'
import Promotions from '@/components/Promotions'
//import PromotionBanner from '@/components/PromotionBanner'
import Gallery from '@/components/Gallery'
// import Supermarket from '@/components/Supermarket'
// import Butchery from '@/components/Butchery'
// import MeatPlant from '@/components/MeatPlant'
// import DistributionCentre from '@/components/DistributionCentre'
import StoreLocator from '@/components/StoreLocator'
import ContactUs from '@/components/ContactUs'
import JFooter from '@/components/Footer'

export default {
  name: 'home',
  components: { MainNav, Landing, AboutUs, Gallery, Promotions, /* PromotionBanner, Supermarket, Butchery, MeatPlant, DistributionCentre, */ StoreLocator, ContactUs, JFooter },
  created: function () {
    window.gtag('event', 'page', {
      'page': '/',
      'title': 'Home'
    })
  },
  data () {
    return {}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Home.vue